import { createApp } from '@backstage/frontend-defaults';
import { appModule } from './appModule';
import { catalogModule } from './components/catalog/catalogPageOverride';
import { homeModule } from './components/home/HomeModule';
import { spogPlugin } from '@internal/plugin-spog';
import { environmentsPlugin } from '@internal/plugin-environments';

// Routes, layout, nav, apis, theme and the sign-in page all come from the
// extension tree; see `app.packages.include` and `app.routes` in
// app-config.yaml, and `appModule` for what this app contributes itself.
const app = createApp({
  features: [
    appModule,
    catalogModule,
    homeModule,
    spogPlugin,
    environmentsPlugin,
  ],
});

export default app;
